export default __webpack_public_path__ + "static/media/cars (1).72bf884b.png";